import axiosInstance from './axiosInstance'

export interface ContactNote {
  id:        string
  contactId: string
  content:   string
  createdBy: { id: string; name: string; email: string; avatarUrl: string | null } | null
  createdAt: string
  updatedAt: string
}

export const contactNotesApi = {
  getAll: (contactId: string) =>
    axiosInstance.get<{ data: ContactNote[] }>(`/contacts/${contactId}/notes`).then(r => r.data.data),

  create: (contactId: string, content: string) =>
    axiosInstance.post<{ data: ContactNote[] }>(`/contacts/${contactId}/notes`, { content }).then(r => r.data.data),

  update: (contactId: string, noteId: string, content: string) =>
    axiosInstance.put<{ data: ContactNote[] }>(`/contacts/${contactId}/notes/${noteId}`, { content }).then(r => r.data.data),

  delete: (contactId: string, noteId: string) =>
    axiosInstance.delete(`/contacts/${contactId}/notes/${noteId}`),
}
